import { Button, CircularProgress, Grid, Stack, Typography } from '@mui/material';
import { Box } from '@mui/system';
import axios from '../../common/api/axiosConfig';
import moment from 'moment/moment';
import { useContext, useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import ErrorSnackbarNotification from '../../common/ErrorHandling/ErrorSnackbarAlert';
import { LanguageContext } from "../../common/features/LanguageWrapper";
import { styles } from '../../style/style';
import { persistor } from '../../store';
import { add, setOrderRequestSearchType, setOrderRequestSearchField } from '../orderlist/orderListSlice';
import { ActualTargetFrom, ActualTargetTo, AdvancedSearchAppName, AdvancedSearchClearButton, AllocationGroupText, ChargeToBacLabel, ChargeToBacText, ChargeToBfc, DanText, Division, EndUserText, EventCodeFrom, EventCodeTo, Model, ModelYear, OrderNumber, PrimaryFanLabel, PrimaryFanText, PurchaseNumber, RecordsToReturn, RequestTargetFrom, RequestTargetTo, ShipToBac, ShipToBacLabel } from './AdvancedSearchComponents';
/* import dayjs from 'dayjs'; */
import 'dayjs/locale/fr';
import log from '../../common/components/Logger'





export default function AdvancedSearch() {
    const login = useSelector((state) => state.login.data.payload.login);

    if (!login) {
        window.location.href = '/home';
    }


    const intl = useIntl();
    const [defaultEventFrom, setDefaultEventFrom] = useState("");
    const [defaultEventTo, setDefaultEventTo] = useState("");
    const [modelYear, setModelYear] = useState([]);
    const [defaultRecordsToReturn, setDefaultRecordToReturn] = useState('All');
    const [modelYearRequired, setModelYearRequired] = useState("");
    const [selectedModelYear, setSelectedModelYear] = useState([]);
    const [errorMessage, setErrorMessage] = useState("");
    const [error, setError] = useState(false);
    const [errorType, setErrorType] = useState("");
    const [primaryFan, setPrimaryFan] = useState('');
    const [endUserFan, setEndUserFan] = useState('');
    const [bacNumber, setBacNumber] = useState('');
    const [chargeToBfc, setChargeToBfc] = useState('');
    const [shipBfc, setShipBac] = useState('');
    const [allocationGroup, setAllocationGroup] = useState('');
    const [dan, setDan] = useState('');
    const [purchaseNum, setPurchaseNum] = useState('');
    const [orderNum, setOrderNum] = useState('');
    const [division, setDivision] = useState([]);
    const [selectedDivision, setSelectedDivision] = useState("");
    const [model, setModel] = useState([]);
    const [distinctModel, setDistinctModel] = useState([]);
    const [selectedModel, setSelectedModel] = useState('');
    const [eventCodeList, setEventCodeList] = useState([]);
    const [selectedEventCodeFrom, setSelectedEventCodeFrom] = useState('');
    const [selectedEventCodeTo, setSelectedEventCodeTo] = useState('');
    const [requestTargetFrom, setRequestTargetFrom] = useState(null);
    const [requestTargetTo, setRequestTargetTo] = useState(null);
    const [actualTargetFrom, setActualTargetFrom] = useState(null);
    const [actualTargetTo, setActualTargetTo] = useState(null);
    const [recordsToReturn, setRecordsToReturn] = useState('');
    const recordsToReturnList = ['All','50', '100', '250', '500', '1000']
    const dispatch = useDispatch();
    const ApiList = useSelector((state) => state.apiList.apiList);
    const [bacFixed, setBacFixed] = useState(false);
    const [primaryFanFixed, setPrimaryFanFixed] = useState(false);
    const [shipBacFixed, setShipBacFixed] = useState(false);
    const [hideEndUserFan, setHideEndUserFan] = useState(true);
    const userDetails = useSelector((state) => state.user.data.payload);
    const childBacs = useSelector((state) => state.childBac?.data?.childBacs || []);
    const [selectedShipBacs, setSelectedShipBacs] = useState([]);
    const [selectedChargeToBacs, setSelectedChargeToBacs] = useState([]);
    const normalizeUniqueBacs = (values) => [...new Set((values || []).map((value) => String(value).trim()).filter((value) => value !== ''))];
    const shipToBacOptions = normalizeUniqueBacs([userDetails?.bac, ...childBacs]);
    const isUpfitter = String(userDetails?.partnerType || '').toUpperCase() === 'UPFITTER';
    const isFleetDealer = String(userDetails?.partnerType || '').toUpperCase() === 'FLEETDEALER';
    const chargeToBacOptions = isFleetDealer ? normalizeUniqueBacs([...childBacs]) : normalizeUniqueBacs([userDetails?.bac, ...childBacs]);
    const lockShipToBacSelection = isUpfitter && childBacs.length === 0;
    const requiresShipToBacSelection = isUpfitter && shipToBacOptions.length > 1;
    const requiresChargeToBacSelection = false; // Charge-to BAC is optional since primary FAN is pre-selected for Fleet Dealers
    /* const idToken = localStorage.getItem("idToken") */
    const [loading, setLoading] = useState(false);


    const context = useContext(LanguageContext);
    let calendarLocale;
    if (localStorage.getItem('locale') !== null || localStorage.getItem('locale') === "") {
        if (localStorage.getItem('locale') == "fr-CA") {
            calendarLocale = "fr";
        }
        else {
            calendarLocale = "en";
        }
    } else {
        if (context.locale === "fr-CA") {
            calendarLocale = "fr";
        } else {
            calendarLocale = "en";
        }
    }


    /* const [tryFrom, setTryFrom] = useState(null); */
    /* const tryRequestTargetFrom = (event) => {
        let formattedDate = moment(event).format('YYYY-MM-DD');
        setTryFrom(formattedDate);
    }; */



    let config;
    const url = ApiList.getsearchinputbyrole;
    const headerConfig = {
        headers: {
            'Content-Type': 'application/json'
        },
    };

    useEffect(() => {
        const data = {
            user: {
                userId: userDetails.userId,
                partnerType: userDetails.partnerType,
                preferredLanguage: userDetails.preferredLanguage,
                bac: userDetails.bac,
                primaryFan: userDetails.primaryFAN
            }
        }

        config = {
            headers: {
                'Content-Type': 'application/json'
            }
        };

        axios.post(url, data, config)
            .then((response) => {
                log.info(`fos_ui_log: AdvancedSearch():getsearchinputbyrole ${response.data.statusMessage}`)
                if (response.status === 200) {
                    setError(false)
                    // For upfitters: Ship-To BAC is either fixed or a dropdown, Charge-To BAC is blank/editable
                    if (String(userDetails?.partnerType || '').toUpperCase() === 'UPFITTER') {
                        if (shipToBacOptions.length > 1) {
                            const defaultShipToBac = normalizeUniqueBacs([response.data.bac, ...shipToBacOptions])[0] || '';
                            const defaultSelection = defaultShipToBac ? [defaultShipToBac] : [];
                            setShipBac(defaultSelection.join(','));
                            setSelectedShipBacs(defaultSelection);
                            setShipBacFixed(false);
                        } else {
                            const defaultShipToBac = normalizeUniqueBacs([response.data.bac, ...shipToBacOptions])[0] || '';
                            const fixedSelection = defaultShipToBac ? [defaultShipToBac] : [];
                            setShipBac(fixedSelection.join(','));
                            setSelectedShipBacs(fixedSelection);
                            setShipBacFixed(true);
                        }
                        // Only clear Charge-To BAC if not already set
                        if (!bacNumber) {
                            setBacNumber('');
                        }
                        setBacFixed(false);
                    } else if (String(userDetails?.partnerType || '').toUpperCase() === 'FLEETDEALER') {
                        // For FLEETDEALER: Charge-To BAC is optional; never auto-select
                        if (!bacNumber) {
                            setBacNumber('');
                            setSelectedChargeToBacs([]);
                        }
                        setBacFixed(false);
                        // Ship-To BAC is editable for FLEETDEALER
                        setShipBac('');
                        setShipBacFixed(false);
                    } else {
                        // For non-upfitters: use standard bacFixed logic
                        setShipBacFixed(false);
                        if (response.data.bacFixed === true) {
                            setBacNumber(response.data.bac)
                            setBacFixed(true);
                        }
                    }
                    if (response.data.primaryFanFixed === true) {
                        setPrimaryFan(response.data.primaryFan)
                        setPrimaryFanFixed(true);
                    }
                    if (response.data.hideEndUserFan === false) {
                        setHideEndUserFan(false);
                    }
                }
            })
            .catch((error) => {
                setError(true);
                setLoading(false);
                setErrorType('error')
                setErrorMessage(intl.formatMessage({ id: error.message.toString().toUpperCase().replace(/ /g, "_"), defaultMessage: error.message }))
                log.error(`fos_ui_log: AdvancedSearch():getsearchinputbyrole ${error.message}`)
            })
    }, [url, userDetails.userId, userDetails.partnerType, userDetails.preferredLanguage, userDetails.bac, userDetails.primaryFAN, intl, shipToBacOptions.length])

    // window.addEventListener ( "pageshow", function (event) {
    //     var historyTraversal = event.persisted ||
    //                             ( typeof this.window.performance != "undefinded" &&
    //                                 this.window.performance.navigation.type === 2);
    //     if (historyTraversal ) {
    //         this.window.location.reload();
    //     }

    // });

    function handleSearch() {
        const url = ApiList.advancedOrderList;
        setError(false);
        setLoading(true);
        setErrorMessage('');

        if (requiresShipToBacSelection && selectedShipBacs.length === 0) {
            setError(true);
            setLoading(false);
            setErrorType('error');
            setErrorMessage(
                intl.formatMessage({
                    id: 'ordersummarycomponents.shiptobacrequired',
                    defaultMessage: 'Select at least one Ship-To BAC to continue.'
                })
            );
            return;
        }

        if (selectedModelYear.length === 0) {
            setModelYearRequired(intl.formatMessage({ id: "ordersummary.modelYearRequired", defaultMessage: "Model Year is Required" }))
        } else {
            setModelYearRequired("")
        }

        let divisionValue = selectedDivision.split(' ')[2];
        let eventCodeFrom;
        let eventCodeTo;
        if (selectedEventCodeFrom === '') {
            eventCodeFrom = defaultEventFrom.split(' ')[0];
        }
        else {
            eventCodeFrom = selectedEventCodeFrom.split(' ')[0];
        }

        if (selectedEventCodeTo === '') {
            eventCodeTo = defaultEventTo.split(' ')[0];
        }
        else {
            eventCodeTo = selectedEventCodeTo.split(' ')[0];
        }


        let data = {
            advancedSearch: {
                primaryFleetAccountNumber: primaryFan,
                endUserFleetAccountNumber: endUserFan,
                chargeToBac: bacNumber,
                chargeToBfc: chargeToBfc,
                shipToBac: shipBfc,
                dealerCode: dan,
                allocationGroup: allocationGroup,
                model: selectedModel,
                modelYear: selectedModelYear.toString(),
                requestedTpwFrom: requestTargetFrom,
                requestedTpwTo: requestTargetTo,
                actualTpwFrom: actualTargetFrom,
                actualTpwTo: actualTargetTo,
                orderNumber: orderNum,
                poNumber: purchaseNum,
                eventCodeFrom: eventCodeFrom,
                eventCodeTo: eventCodeTo,
                recordsToReturn: recordsToReturn,
                partnerType: userDetails.partnerType,
                division: divisionValue
            }
        }

        config = {
            headers: {
                'Content-Type': 'application/json'
            }
        };


        let navigatePath = '/orderrequestlist';


        dispatch(setOrderRequestSearchType('OrderList'));
        dispatch(setOrderRequestSearchField(data));
        persistor.flush().then(() => {
            window.location.href = navigatePath;
        });

        /*
        axios.post(url, data, config)
            .then((response) => {
                if (response.data.advancedSearchValid === true) {

                    if (response.data.statusMessage === 'SUCCESS') {
                        log.info(`fos_ui_log: AdvancedSearch():handleSearch: ${response.data.statusMessage}`)

                        // limit the data to only 8000 lines or below 
                        const orderRequestList = response.data.orderRequestList.length > 7000 ? response.data.orderRequestList.slice(0, 7000) :response.data.orderRequestList;
                        const newData = {...response.data, orderRequestList: orderRequestList}
                        setLoading(false);
                        dispatch(add(newData));
                        dispatch(setOrderRequestSearchType('leftClick'));
                        window.location.href = navigatePath;
                    }
                    else {
                        setError(true);
                        setLoading(false);
                        setErrorType('error');
                        if (response.data.statusMessage !== null) {
                            setErrorMessage(intl.formatMessage({ id: response.data.statusMessage, defaultMessage: "Error Found" }))
                            log.info(`fos_ui_log: AdvancedSearch():handleSearch: ${response.data.statusMessage}`)
                        }
                    }

                } else {
                    setError(true);
                    setLoading(false);
                    let errorMessage = [];
                    if (response.data.invalidPrimaryFanMessage !== null) {
                        errorMessage.push(intl.formatMessage({ id: response.data.invalidPrimaryFanMessage, defaultMessage: "Error Found" }));
                        log.info(`fos_ui_log: AdvancedSearch():invalidPrimaryFanMessage: ${response.data.invalidPrimaryFanMessage}`)
                    }
                    if (response.data.invalidEndUserFanMessage !== null) {
                        errorMessage.push(intl.formatMessage({ id: response.data.invalidEndUserFanMessage, defaultMessage: "Error Found" }));
                        log.info(`fos_ui_log: AdvancedSearch():invalidEndUserFanMessage: ${response.data.invalidEndUserFanMessage}`)
                    }
                    if (response.data.invalidChargeToBacMessage !== null) {
                        errorMessage.push(intl.formatMessage({ id: response.data.invalidChargeToBacMessage, defaultMessage: "Error Found" }));
                        log.info(`fos_ui_log: AdvancedSearch():invalidChargeToBacMessage: ${response.data.invalidChargeToBacMessage}`)
                    }
                    if (response.data.invalidChargeToBfcMessage !== null) {
                        errorMessage.push(intl.formatMessage({ id: response.data.invalidChargeToBfcMessage, defaultMessage: "Error Found" }));
                        log.info(`fos_ui_log: AdvancedSearch():invalidChargeToBfcMessage: ${response.data.invalidChargeToBfcMessage}`)
                    }
                    if (response.data.invalidShipToBacMessage !== null) {
                        errorMessage.push(intl.formatMessage({ id: response.data.invalidShipToBacMessage, defaultMessage: "Error Found" }));
                        log.info(`fos_ui_log: AdvancedSearch():invalidShipToBacMessage: ${response.data.invalidShipToBacMessage}`)
                    }
                    if (response.data.statusMessage !== '' && response.data.statusMessage !== null) {
                        errorMessage.push(intl.formatMessage({ id: response.data.statusMessage, defaultMessage: "Error Found" }));
                        log.info(`fos_ui_log: AdvancedSearch(): ${response.data.statusMessage}`)
                    }
                    setErrorType('error');
                    setErrorMessage(errorMessage);
                }
            })
            .catch((error) => {
                setError(true);
                setLoading(false);
                setErrorType('error');
                setErrorMessage(intl.formatMessage({ id: error.message.toString().toUpperCase().replace(/ /g, "_"), defaultMessage: error.message }))
                log.error(`fos_ui_log: AdvancedSearch():handleSearch ${error.message}`)
            })*/

    }


    useEffect(() => {
        axios.get(ApiList.getModelYear, headerConfig)
            .then((res) => {
                setModelYear(res.data.activeYears)
                setSelectedModelYear([res.data.activeYears[res.data.activeYears.length - 1]])
                log.info(`fos_ui_log: AdvancedSearch():getModelYear ${res.data.activeYears}`)
                axios.get(ApiList.getModel,
                    {
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        params: {
                            year: res.data.activeYears[res.data.activeYears.length - 1]
                        }
                    })
                    .then((res2) => {
                        setModel(res2.data.modelList)
                        setDistinctModel(res2.data.distinctModelList)
                        log.info(`fos_ui_log: AdvancedSearch():getModel ${res2.data.modelList}`)
                    }).catch((error) => {
                        log.error(`fos_ui_log: AdvancedSearch():getModel ${error.message}`)
                    })
            })
            .catch((error) => {
                log.error(`fos_ui_log: AdvancedSearch():getModelYear ${error.message}`)
            })

    }, []);

    useEffect(() => {
        axios.get(ApiList.getDivision, headerConfig)
            .then((res) => {
                setDivision(res.data.divisionList)
                log.info(`fos_ui_log: AdvancedSearch():getDivision ${res.data.divisionList}`)
            }).catch((error) => {
                log.error(`fos_ui_log: AdvancedSearch():getDivision ${error.message}`)
            })
    }, []);

    useEffect(() => {
        axios.get(ApiList.advancedOrderList, headerConfig)
            .then((res) => {
                setDefaultRecordToReturn(res.data.recordsToReturnList[0])
                log.info(`fos_ui_log: AdvancedSearch():advancedOrderList ${res.data.recordsToReturnList}`)
            }).catch((error) => {
                log.error(`fos_ui_log: AdvancedSearch():advancedOrderList ${error.message}`)
            })
    }, []);

    useEffect(() => {
        const eventconfig = {
            headers: {
                'Content-Type': 'application/json'
            },
            params: {
                partnerType: userDetails.partnerType
            }
        };
        if (eventCodeList.length === 0) {
            axios.get(ApiList.getEventCodes, eventconfig)
                .then((res) => {
                    setEventCodeList(res.data.eventCodeList)
                    setDefaultEventFrom(res.data.eventCodeList[0].vehEventCodes)
                    setDefaultEventTo(res.data.eventCodeList[res.data.eventCodeList.length - 1].vehEventCodes)
                    log.info(`fos_ui_log: AdvancedSearch():getEventCodes ${res.data.eventCodeList}`)
                })
                .catch((error) => {
                    log.error(`fos_ui_log: AdvancedSearch():getEventCodes ${error.message}`)
                })
        }
    }, []);

    const handleChange = (event) => {
        const {
            target: { value },
        } = event;
        if (event.target.value.includes("ALL")) {
            axios.get(ApiList.getModelYear, headerConfig)
                .then((res) => {
                    setSelectedModelYear(res.data.activeYears)
                    log.info(`fos_ui_log: AdvancedSearch():getModelYear ${res.data.activeYears}`)
                })
                .catch((error) => {
                    log.error(`fos_ui_log: AdvancedSearch():getModelYear ${error.message}`)
                })
        } else {
            setSelectedModelYear(
                // On autofill we get a stringified value.
                typeof value === 'string' ? value.split(',') : value,
            )
        }

        axios.get(ApiList.getModel,
            {
                headers: {
                    'Content-Type': 'application/json'
                },
                params: {
                    year: event.target.value.toString()
                }
            })
            .then((res) => {
                setModel(res.data.modelList)
                setDistinctModel(res.data.distinctModelList)
                log.info(`fos_ui_log: AdvancedSearch():getModel ${res.data.modelList}`)
            }).catch((error) => {
                log.error(`fos_ui_log: AdvancedSearch():getModel ${error.message}`)
            })
    };

    const handleDivChange = (event) => {
        setSelectedDivision(event.target.value);
    };

    const handleModelChange = (event) => {
        setSelectedModel(event.target.value);
    };

    const handleEventCodeFrom = (event) => {
        setSelectedEventCodeFrom(event.target.value);
    };

    const handleEventCodeTo = (event) => {
        setSelectedEventCodeTo(event.target.value);
    };

    const onChangePrimaryFan = (event) => {
        setPrimaryFan(event.target.value);
    }

    const onChangeEndUserFan = (event) => {
        setEndUserFan(event.target.value);
    }

    const onChangeChargeToBfc = (event) => {
        setChargeToBfc(event.target.value);
    }

    const onChangeShipBac = (event) => {
        setShipBac(event.target.value);
    }
    const onChangeShipBacSelection = (event) => {
        if (lockShipToBacSelection) {
            const fallbackBac = normalizeUniqueBacs([shipBfc, userDetails?.bac])[0] || '';
            const lockedValue = fallbackBac ? [fallbackBac] : [];
            setSelectedShipBacs(lockedValue);
            setShipBac(lockedValue.join(','));
            setError(false);
            setErrorMessage('');
            return;
        }

        const {
            target: { value },
        } = event;
        const selectedValues = normalizeUniqueBacs(typeof value === 'string' ? value.split(',') : value);
        setSelectedShipBacs(selectedValues);
        setShipBac(selectedValues.join(','));
        setError(false);
        setErrorMessage('');
    }
    const onChangeChargeToBac = (event) => {
        setBacNumber(event.target.value);
    }

    const onChangeChargeToBacSelection = (event, newValue) => {
        // Handle "Select All" option
        if (newValue.includes('SELECT_ALL')) {
            // If all were already selected, clear all
            if (selectedChargeToBacs.length === chargeToBacOptions.length) {
                setSelectedChargeToBacs([]);
                setBacNumber('');
            } else {
                // Select all options
                setSelectedChargeToBacs(chargeToBacOptions);
                setBacNumber(chargeToBacOptions.join(','));
            }
        } else {
            setSelectedChargeToBacs(newValue);
            setBacNumber(newValue.join(','));
        }
    }

    const onChangeAllocationGroup = (event) => {
        setAllocationGroup(event.target.value);
    }

    const onChangeDan = (event) => {
        setDan(event.target.value);
    }

    const onChangePurchaseNum = (event) => {
        setPurchaseNum(event.target.value);
    }


    const onChangeOrderNum = (event) => {
        setOrderNum(event.target.value);
    }


    const handleRequestTargetFrom = (event) => {
        /* setRequestTargetFrom(event.target.value); */
        let formattedDate = moment(event).format('YYYY-MM-DD');
        setRequestTargetFrom(formattedDate);
    };



    const handleRequestTargetTo = (event) => {
        /* setRequestTargetTo(event.target.value); */
        let formattedDate = moment(event).format('YYYY-MM-DD');
        setRequestTargetTo(formattedDate);
    };

    const handleActualTargetFrom = (event) => {
        /* setActualTargetFrom(event.target.value); */
        let formattedDate = moment(event).format('YYYY-MM-DD');
        setActualTargetFrom(formattedDate);
    };

    const handleActualTargetTo = (event) => {
        /* setActualTargetTo(event.target.value); */
        let formattedDate = moment(event).format('YYYY-MM-DD');
        setActualTargetTo(formattedDate);
    };

    const handleRecordsToReturn = (event) => {
        setRecordsToReturn(event.target.value);
    };

    const handleClose = (reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setError(false);
    };

    const clearForm = () => {

        if (userDetails.partnerType === "GM_Corporate" || userDetails.partnerType === "GM_Wholesale") {
            setBacNumber('');
        }

        // Only clear Primary FAN if it's not locked (user-editable)
        if (!primaryFanFixed) {
            setPrimaryFan('');
        }
        setEndUserFan('');
        setChargeToBfc('');
        if (requiresShipToBacSelection) {
            setShipBac('');
            setSelectedShipBacs([]);
        } else if (lockShipToBacSelection) {
            const fallbackBac = normalizeUniqueBacs([shipBfc, userDetails?.bac])[0] || '';
            const lockedValue = fallbackBac ? [fallbackBac] : [];
            setSelectedShipBacs(lockedValue);
            setShipBac(lockedValue.join(','));
        } else {
            setShipBac('');
            setSelectedShipBacs([]);
        }
        // Only clear Charge-To BAC if it's not locked
        if (!bacFixed) {
            setBacNumber('');
            setSelectedChargeToBacs([]);
        }
        setSelectedModelYear([]);
        setSelectedDivision(''); setSelectedModel(''); setSelectedEventCodeFrom('');
        setDan(''); setAllocationGroup(''); setRequestTargetFrom(null); setRequestTargetTo(null);
        setActualTargetFrom(null); setActualTargetTo(null); setOrderNum('');
        setPurchaseNum(''); setSelectedEventCodeFrom('');
        setSelectedEventCodeTo(''); setRecordsToReturn('');
        setErrorMessage('');
        setModelYearRequired('');
    }

    return (
        <Box sx={{width: '100vw', overflowX: 'hidden'}}>
            <Grid container sx={styles.masterMargin}>
                <Grid size={12}>
                    <Grid id='advancedSearchAppName' sx={{ mb: 4 }}>
                        <AdvancedSearchAppName />
                    </Grid><Stack spacing={2} sx={{ ...styles.advancedSearchStackVertical, mb: 3 }}>
                    
                        <Stack spacing={3} direction='row'>
                            <Grid size={6}>
                                {userDetails.partnerType !== 'FLEET' && (<Typography id='fanLabel' variant="h4" sx={styles.h4InformationGroupHeader} ><FormattedMessage id="advancedsearchcomponents.primaryfan" defaultMessage="Primary Fleet Account Number (FAN)" /></Typography>)}
                                {userDetails.partnerType === 'FLEET' && (<Typography id='fanLabel' variant="h4" sx={styles.h4InformationGroupHeader} ><FormattedMessage id="advancedsearchcomponents.fan" defaultMessage="Fleet Account Number (FAN)" /></Typography>)}
                            </Grid>
                            <Grid size={6}>
                                <Typography id="bacLabel" variant="h4" sx={styles.h4InformationGroupHeader} ><FormattedMessage id="advancedsearchcomponents.BAC" defaultMessage="Business Associate Code (BAC)" /></Typography>
                            </Grid>
                        </Stack>

                        <Stack spacing={3} direction='row'>
                            {primaryFanFixed === true ? (
                                <Grid id='primaryFanLabel' size={3}>
                                    <PrimaryFanLabel primaryFan={primaryFan} />
                                </Grid>
                            ) : (
                                <Grid id='primaryFanText' size={3}>
                                    <PrimaryFanText value={primaryFan} id='primaryFan' onChangePrimaryFan={onChangePrimaryFan} />
                                </Grid>
                            )}

                            <Grid id='endUserFanGrid' size={3}>
                                {hideEndUserFan === false ? (
                                    <EndUserText value={endUserFan} id='endUserFan' onChangeEndUserFan={onChangeEndUserFan} />
                                ) : (
                                    null
                                )}
                            </Grid>

                            {bacFixed === true ? (
                                <Grid id='chargeToBacGridLabel' size={3}>
                                    <ChargeToBacLabel bacNumber={bacNumber} />
                                </Grid>
                            ) : (
                                <Grid id='chargeToBacGridText' size={3}>
                                    <ChargeToBacText 
                                        value={bacNumber} 
                                        id='chargeToBac' 
                                        onChangeChargeToBac={onChangeChargeToBac}
                                        isFleetDealer={isFleetDealer}
                                        bacOptions={isFleetDealer && chargeToBacOptions.length >= 1 ? ['SELECT_ALL', ...chargeToBacOptions] : chargeToBacOptions}
                                        selectedValues={selectedChargeToBacs}
                                        onChangeChargeToBacSelection={onChangeChargeToBacSelection}
                                    />
                                </Grid>
                            )}
                            {shipBacFixed === true ? (
                                <Grid id='shipToBacLabel' size={3}>
                                    <ShipToBacLabel bacNumber={shipBfc} />
                                </Grid>
                            ) : (
                                <Grid id='shipToBac' size={3}>
                                    <ShipToBac
                                        value={shipBfc}
                                        id='shipBac'
                                        onChangeShipBac={onChangeShipBac}
                                        isUpfitter={String(userDetails?.partnerType || '').toUpperCase() === 'UPFITTER'}
                                        options={shipToBacOptions}
                                        selectedValues={selectedShipBacs}
                                        onChangeShipBacSelection={onChangeShipBacSelection}
                                        disableSelection={lockShipToBacSelection}
                                    />
                                </Grid>
                            )}
                        </Stack>
                    </Stack>


                    <Stack spacing={2} sx={{ ...styles.advancedSearchStackVertical, mb: 3 }}>
                        <Stack spacing={3} direction='row'>
                            <Grid size={3}>
                                <Typography id="bfcLabel" variant="h4" sx={styles.h4InformationGroupHeader} ><FormattedMessage id="advancedsearchcomponents.businessFunctionCode" defaultMessage="Business Function Code (BFC)" /></Typography>
                            </Grid>
                            <Grid size={3}>
                                <Typography id="danLabel" variant="h4" sx={styles.h4InformationGroupHeader} ><FormattedMessage id="advancedsearchcomponents.dealerAssignedNumber" defaultMessage="Dealer Assigned Number (DAN)" /></Typography>
                            </Grid>
                            <Grid size={3}>
                                <Typography id="orderNumberLabel" variant="h4" sx={styles.h4InformationGroupHeader} ><FormattedMessage id="advancedsearchcomponents.orderNumber" defaultMessage="Order Number" /></Typography>
                            </Grid>
                            <Grid size={3}>
                                <Typography id="purchaseOrderLabel" variant="h4" sx={styles.h4InformationGroupHeader} ><FormattedMessage id="advancedsearchcomponents.purchaseOrderNumber" defaultMessage="Purchase Order (PO) Number" /></Typography>
                            </Grid>
                        </Stack>

                        <Stack spacing={3} direction='row'>
                            <Grid size={3}>
                                <Stack spacing={3} >
                                    <Grid id='chargeToBfc' size={12}>
                                        <ChargeToBfc value={chargeToBfc} id='chargeToBfc' onChangeChargeToBfc={onChangeChargeToBfc} />
                                    </Grid>
                                </Stack>
                            </Grid>
                            <Grid size={3}>
                                <Stack spacing={3} >
                                    <Grid id='dan' size={12}>
                                        <DanText value={dan} id='dan' onChangeDan={onChangeDan} />
                                    </Grid>
                                </Stack>
                            </Grid>
                            <Grid size={3}>
                                <Stack spacing={3} direction='row'>
                                    <Grid id='orderNumber' size={12}>
                                        <OrderNumber value={orderNum} id='orderNum' onChangeOrderNum={onChangeOrderNum} />
                                    </Grid>
                                </Stack>
                            </Grid>
                            <Grid size={3}>
                                <Stack spacing={3} direction='row'>
                                    <Grid id='purchaseOrder' size={12}>
                                        <PurchaseNumber value={purchaseNum} id='purchaseNum' onChangePurchaseNum={onChangePurchaseNum} />
                                    </Grid>
                                </Stack>
                            </Grid>
                        </Stack>
                    </Stack>


                    <Stack>
                        <Stack spacing={2} sx={{ ...styles.advancedSearchStackVertical, mb: 3 }}>
                            <Typography id="vehicleInfoLabel" variant="h4" sx={styles.h4InformationGroupHeader} ><FormattedMessage id="advancedsearchcomponents.vehicleInformation" defaultMessage="Vehicle Information" /></Typography>

                            <Stack spacing={3} direction='row'>
                                <Grid id='modelYear' size={3}>
                                    <ModelYear options={modelYear} value={selectedModelYear} handleChange={handleChange} modelYearRequired={modelYearRequired} />
                                </Grid>
                                <Grid id='division' size={3}>
                                    <Division options={division} value={selectedDivision} handleDivChange={handleDivChange} />
                                </Grid>
                                <Grid id='allocationGroup' size={3}>
                                    <AllocationGroupText value={allocationGroup} id='allocationGroup' onChangeAllocationGroup={onChangeAllocationGroup} />
                                </Grid>
                                <Grid id='model' size={3}>
                                    <Model selectedDivision={selectedDivision} selectedModelYr={selectedModelYear} distinctModel={distinctModel} options={model} value={selectedModel} handleModelChange={handleModelChange} />
                                </Grid>
                            </Stack>
                        </Stack>
                    </Stack>
                    <Stack spacing={4} direction='row' sx={styles.advancedSearchStack}>
                        <Grid size={6}>
                            <Stack spacing={3} >
                                {/* <Typography id="orderNumberLabel" variant="h4" sx={styles.h4InformationGroupHeader} >Order Number</Typography>
                                <Stack spacing={2} direction='row'>
                                    <Grid id='orderNumber' size={6}>
                                        <OrderNumber value={orderNum} id='orderNum' onChangeOrderNum={onChangeOrderNum} />
                                    </Grid>
                                </Stack> */}
                                <Typography id="requestTargetLabel" variant="h4" sx={styles.h4InformationGroupHeader} ><FormattedMessage id="advancedsearchcomponents.requestedTargetProductionWeek" defaultMessage="Requested Target Production Week (TPW)" /></Typography>

                                <Stack spacing={3} direction='row'>
                                    <Grid id='requestTargetFrom' size={6}>
                                        <RequestTargetFrom calendarLocale={calendarLocale} disableToDate={requestTargetTo} requestTargetFrom={requestTargetFrom} handleRequestTargetFrom={handleRequestTargetFrom} />
                                    </Grid>
                                    <Grid id='requestTargetTo' size={6}>
                                        <RequestTargetTo calendarLocale={calendarLocale} disableFromDate={requestTargetFrom} requestTargetTo={requestTargetTo} handleRequestTargetTo={handleRequestTargetTo} />
                                    </Grid>
                                </Stack>

                                <Typography id="eventCodeLabel" variant="h4" sx={styles.h4InformationGroupHeader} ><FormattedMessage id="advancedsearchcomponents.eventCode" defaultMessage="Event Code" /></Typography>
                                <Stack spacing={3} direction='row'>
                                    <Grid id='eventCodeFrom' size={6}>
                                        <EventCodeFrom defaultEventFrom={defaultEventFrom} options={eventCodeList} value={selectedEventCodeFrom} handleEventCodeFrom={handleEventCodeFrom} />
                                    </Grid>
                                    <Grid id='eventCodeTo' size={6}>
                                        <EventCodeTo defaultEventTo={defaultEventTo} options={eventCodeList} value={selectedEventCodeTo} handleEventCodeFrom={handleEventCodeTo} />
                                    </Grid>
                                </Stack>
                            </Stack>

                        </Grid>
                        <Grid size={6}>
                            <Stack spacing={3} >
                                {/* <Typography id="purchaseOrderLabel" variant="h4" sx={styles.h4InformationGroupHeader} >Purchase Order (PO) Number</Typography>
                                <Stack spacing={2} direction='row'>
                                    <Grid id='purchaseOrder' size={6}>
                                        <PurchaseNumber value={purchaseNum} id='purchaseNum' onChangePurchaseNum={onChangePurchaseNum} />
                                    </Grid>
                                </Stack> */}
                                <Typography id="actualTargetLabel" variant="h4" sx={styles.h4InformationGroupHeader} ><FormattedMessage id="advancedsearchcomponents.actualTargetProductionWeek" defaultMessage="Actual Target Production Week (TPW)" /></Typography>
                                <Stack spacing={3} direction='row'>
                                    <Grid id='actualTargetFrom' size={6}>
                                        <ActualTargetFrom calendarLocale={calendarLocale} disableToDate={actualTargetTo} actualTargetFrom={actualTargetFrom} handleActualTargetFrom={handleActualTargetFrom} />
                                    </Grid>
                                    <Grid id='actualTargetTo' size={6}>
                                        <ActualTargetTo calendarLocale={calendarLocale} disableFromDate={actualTargetFrom} actualTargetTo={actualTargetTo} handleActualTargetTo={handleActualTargetTo} />
                                    </Grid>
                                </Stack>
                                <Typography id="recordsToReturnLabel" variant="h4" sx={styles.h4InformationGroupHeader} ><FormattedMessage id="advancedsearchcomponents.recordstoreturn" defaultMessage="Records To Return" /></Typography>
                                <Stack>
                                    <Grid id='recordsToReturn' size={6}>
                                        <RecordsToReturn defaultRecordsToReturn={defaultRecordsToReturn} value={recordsToReturn} options={recordsToReturnList} onChange={handleRecordsToReturn} />
                                    </Grid>
                                </Stack>
                            </Stack>
                        </Grid>
                    </Stack>
                    <Grid id='buttons'>
                        <Stack direction='row' spacing={2} sx={styles.orderSummaryStackButton}>
                            <AdvancedSearchClearButton onChange={clearForm} />
                            {loading !== true ? (
                                <Button id="searchButton" sx={styles.orderSummarySearch} onClick={handleSearch} ><FormattedMessage id='ordersummarycomponents.search' defaultMessage='Search' /></Button>
                            ) : (
                                <Button sx={styles.orderSummarySearch}><CircularProgress sx={styles.loadingSpinner} size={20} /></Button>
                            )}
                        </Stack>
                    </Grid>
                </Grid>
            </Grid>
            {errorMessage.length > 0 &&
                <ErrorSnackbarNotification errorType={errorType} open={error} handleClose={handleClose} errorMessage={errorMessage} />
            }
            {/* <ToastNotification type={'error'} open={error} handleAlert={() => {setError(false)}} autoHideDuration={5000} message={errorMessage} /> */}
        </Box>
    )
}
